var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsland(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.002,
    height: 157.624,
    viewBox: "0 0 177.002 157.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712",
    transform: "translate(-675.154 -296.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_607",
    "data-name": "Path 607",
    d: "M732.9,406.366c14.058-11.441,31.268-15.362,51.884-11.9a176.785,176.785,0,0,0-9.807-67.511c-7.579,4.913-10.854,11.7-11.117,20.706-6.6-6.286-6.63-12.756-2.859-19.786l-1.07-.6-10.769,11.053c-3.537-9.136.321-16.772,11.395-23.326L747.4,317.257c2.04-9.45,10.83-13.611,23-10.73,7.117-10.212,16.375-12.949,24.048-7.5l-11.688,7.54c13.57-2.735,22.2.426,24.413,9.008H791.6c8.839,3.935,12.639,9.3,11,16.438-5.765-5.646-12.4-8.546-20.935-7.2a187,187,0,0,1,10.2,68.854l21.365-34.065c-4.3-2.839-9.331-2.212-14.72-.615,1.909-5.523,5.869-7.121,10.76-8.29l-9.038-3.324c5.3-4.788,9.869-4.607,17.558.249l-4.931-7.356c6.966-.871,11.141,2.627,13.377,11.067,8.546,1.46,13.012,6.554,11.252,12.908-1.16-.9-2.244-1.876-3.462-2.642-1.176-.74-2.491-1.261-4.477-2.239,6.146,7.8,6.4,13.435,1.568,17.461-1.175-2.873-2.387-5.833-3.6-8.795-.82,5.16-2.384,9.046-7.6,11.032V364.979c-7.69,6.789-19.316,25.891-21.47,34.544,3.156,2.311,5.927,4.4,8.369,6.323C825.961,410.127,838.7,417.73,838.7,426.4c0,13.382-135.428,13.382-135.428,0C703.271,418.072,715.017,410.727,732.9,406.366Z",
    transform: "translate(-5.637)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1699",
    "data-name": "Group 1699",
    transform: "translate(832.262 414.37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_608",
    "data-name": "Path 608",
    d: "M883.023,451.336a.8.8,0,0,1-.674-.368c-1.923-3-4.549-4.413-10.035-5.4a.8.8,0,1,1,.284-1.574c5.916,1.067,8.924,2.723,11.1,6.112a.8.8,0,0,1-.242,1.1A.79.79,0,0,1,883.023,451.336Z",
    transform: "translate(-871.656 -443.98)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1700",
    "data-name": "Group 1700",
    transform: "translate(675.154 416.651)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_609",
    "data-name": "Path 609",
    d: "M675.954,460.544a.8.8,0,0,1-.8-.8c0-3.787,2.9-7.371,8.612-10.651a48.6,48.6,0,0,1,4.341-2.189.8.8,0,1,1,.653,1.46,46.57,46.57,0,0,0-4.2,2.116c-5.109,2.933-7.809,6.136-7.809,9.264A.8.8,0,0,1,675.954,460.544Z",
    transform: "translate(-675.154 -446.833)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1701",
    "data-name": "Group 1701",
    transform: "translate(684.324 439.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_610",
    "data-name": "Path 610",
    d: "M703.442,482.723a.786.786,0,0,1-.21-.028,78.148,78.148,0,0,1-16.187-6.087.8.8,0,1,1,.758-1.408,76.548,76.548,0,0,0,15.849,5.952.8.8,0,0,1-.209,1.571Z",
    transform: "translate(-686.623 -475.105)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1702",
    "data-name": "Group 1702",
    transform: "translate(727.454 450.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_611",
    "data-name": "Path 611",
    d: "M776.769,492.524c-6.563,0-13.116-.2-19.476-.581-5.474-.333-10.864-.81-16.019-1.421a.8.8,0,1,1,.188-1.588c5.126.607,10.484,1.082,15.927,1.413,8.688.526,17.717.7,26.74.5h.018a.8.8,0,0,1,.018,1.6C781.7,492.5,779.215,492.524,776.769,492.524Z",
    transform: "translate(-740.568 -488.928)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1703",
    "data-name": "Group 1703",
    transform: "translate(798.259 442.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_612",
    "data-name": "Path 612",
    d: "M829.926,488.654a.8.8,0,0,1-.094-1.594c13.723-1.627,25.731-4.2,34.726-7.427a.8.8,0,1,1,.54,1.5c-9.107,3.272-21.236,5.869-35.078,7.51A.751.751,0,0,1,829.926,488.654Z",
    transform: "translate(-829.127 -479.587)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1704",
    "data-name": "Group 1704",
    transform: "translate(840.106 428.763)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_613",
    "data-name": "Path 613",
    d: "M882.267,474.736a.8.8,0,0,1-.357-1.516c6.547-3.26,10.008-6.87,10.008-10.439a.8.8,0,1,1,1.6,0c0,4.277-3.665,8.27-10.894,11.871A.8.8,0,0,1,882.267,474.736Z",
    transform: "translate(-881.466 -461.982)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1705",
    "data-name": "Group 1705",
    transform: "translate(691.548 413.746)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_614",
    "data-name": "Path 614",
    d: "M696.458,449.852a.8.8,0,0,1-.464-1.452,43.407,43.407,0,0,1,10.758-5.156.8.8,0,1,1,.523,1.512A41.806,41.806,0,0,0,696.92,449.7.794.794,0,0,1,696.458,449.852Z",
    transform: "translate(-695.658 -443.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1706",
    "data-name": "Group 1706",
    transform: "translate(686.962 425.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_615",
    "data-name": "Path 615",
    d: "M698.082,468.056a.8.8,0,0,1-.382-.1c-5.16-2.809-7.777-5.9-7.777-9.18a.8.8,0,0,1,1.6,0c0,2.615,2.4,5.3,6.943,7.776a.8.8,0,0,1-.383,1.5Z",
    transform: "translate(-689.923 -457.979)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1707",
    "data-name": "Group 1707",
    transform: "translate(702.776 437.608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_616",
    "data-name": "Path 616",
    d: "M719.914,477.274a.832.832,0,0,1-.182-.021c-3.452-.8-6.642-1.7-9.484-2.651a.8.8,0,1,1,.508-1.516c2.8.939,5.936,1.817,9.338,2.61a.8.8,0,0,1-.18,1.578Z",
    transform: "translate(-709.703 -473.044)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1708",
    "data-name": "Group 1708",
    transform: "translate(720.674 441.951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_617",
    "data-name": "Path 617",
    d: "M757.73,482.881l-.049,0a226.341,226.341,0,0,1-24.932-2.815.8.8,0,0,1,.275-1.576,224.614,224.614,0,0,0,24.753,2.8.8.8,0,0,1-.048,1.6Z",
    transform: "translate(-732.088 -478.476)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1709",
    "data-name": "Group 1709",
    transform: "translate(762.856 444.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_618",
    "data-name": "Path 618",
    d: "M785.646,484.015a.8.8,0,1,1,0-1.6c7.567,0,15.031-.289,22.188-.858a.8.8,0,0,1,.126,1.594C800.761,483.725,793.254,484.015,785.646,484.015Z",
    transform: "translate(-784.846 -481.556)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    "data-name": "Group 1710",
    transform: "translate(790.891 440.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_619",
    "data-name": "Path 619",
    d: "M820.711,481.714a.8.8,0,0,1-.081-1.6,190.439,190.439,0,0,0,20.153-3.1.8.8,0,0,1,.336,1.563,192.186,192.186,0,0,1-20.325,3.127C820.766,481.713,820.738,481.714,820.711,481.714Z",
    transform: "translate(-819.912 -477.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1711",
    "data-name": "Group 1711",
    transform: "translate(822.087 415.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    "data-name": "Path 620",
    d: "M859.729,469.459a.8.8,0,0,1-.246-1.561c10.388-3.364,16.11-7.47,16.11-11.564,0-3.085-3.266-6.2-9.446-9.019a.8.8,0,0,1,.664-1.455c6.888,3.139,10.382,6.662,10.382,10.475,0,4.915-5.954,9.439-17.217,13.086A.8.8,0,0,1,859.729,469.459Z",
    transform: "translate(-858.929 -445.787)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsland);
export default __webpack_public_path__ + "static/media/island.cb3a4a69b6be7124967902c1f1ef7220.svg";
export { ForwardRef as ReactComponent };